export const FAMILIES = {
  NOLE: "nole",
  ROGAN: "rogan",
  TOKASH: "tokash",
  KERRIGAN: "kerrigan",
  LOCAL: "local",
  ROGAN_DIR: "rogan-dir",
};
